import Vue from "vue";
import VueTailwind from "vue-tailwind";
import LibrarySettings from "vue-tailwind/dist/types/LibrarySettings";

import NotificationVTComponentSetting from "@/models/notification.model";
import CardVTComponentSetting from "@/models/card.model";

const setup = () => {
  const pluginSettings: LibrarySettings = {
    ...NotificationVTComponentSetting,
    ...CardVTComponentSetting
  };
  Vue.use(VueTailwind, pluginSettings);
};

export { setup };
